// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__7XTha","text":"SelectPayment_text__3UYf2","title":"SelectPayment_title__2aXNM","btn":"SelectPayment_btn__3xvP-"};